import { Component, ElementRef, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface VideoBlockViewModel {
    Header?: string;
    VideoUrl?: string;
    Summary?: string;
}

@Component({
    selector: 'video-block',
    templateUrl: './video-block.component.html',
    styles: [`
        .swapa-video-block {
            width: 100%;
            max-width: 100%;
        }

        .swapa-video-block-header {
            color: #084F71;
            font-family: "URW DIN Condensed", Arial, sans-serif;
            font-size: 1.625rem;
            font-weight: 700;
            line-height: 1.75rem;
            letter-spacing: 0;
            margin-top: 1rem;
            margin-bottom: 0;
            overflow-wrap: anywhere;
            overflow-wrap: anywhere;
        }

        .swapa-video-block-media {
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 56.25%;
            background-color: #000;
            overflow: hidden;
        }

        .swapa-video-block-player {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
            display: block;
        }

        .swapa-video-block-summary {
            font-family: "Nimbus Sans", Arial, sans-serif;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.25rem;
            color: #5A5A5A;
            margin-top: 0.5rem;
            margin-bottom: 0;
            margin-bottom: 0;
            overflow-wrap: anywhere;
        }

        /* Phones (portrait, or landscape - wide but short): up to 2-line header, 3-line summary.
           Desktop and iPad show the full text. */
        @media (max-width: 767.98px), (max-height: 575.98px) and (orientation: landscape) {
            .swapa-video-block-header {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }

            .swapa-video-block-summary {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }

      
    `],
})
export class VideoBlockComponent implements OnInit {
    public config: VideoBlockViewModel | null = null;
    public playerUrl: SafeResourceUrl | null = null;

    constructor(private host: ElementRef<HTMLElement>, private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        // The server sends the whole block as JSON in an attribute; attributes survive Angular taking over the host element.
        const json = this.host.nativeElement.getAttribute('config');
        if (!json) {
            return;
        }

        try {
            this.config = JSON.parse(json) as VideoBlockViewModel;
        } catch {
            this.config = null;
        }

        if (this.config && this.config.VideoUrl) {
            // playsinline keeps iOS Safari from forcing the video into its native fullscreen player.
            const separator = this.config.VideoUrl.indexOf('?') === -1 ? '?' : '&';
            this.playerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.config.VideoUrl + separator + 'playsinline=1');
        }
    }
}
